<template>
   <div>
       <Breadcrumbs main="Attributes" title="Add Attributes" />
        <div class="container-fluid">
           <div class="row">
              <div class="col-sm-12">
                 <div class="card">
                    <div class="card-body">
                       <form @submit.prevent="addAttribute" enctype="multipart/form-data">
                          <div class="form theme-form">
                              <div class="row">
                                 <div class="col-sm-6">
                                    <div class="mb-3">
                                       <label class="control-label">Name <span class="text-danger">*</span></label>
                                       <!-- <input class="form-control" type="text" placeholder=""> -->
                                       <input class="form-control" type="text" placeholder="" v-model="attribute.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
                                       <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback"> 
                                          <p class="mb-0">{{val}}</p>
                                       </div> 
                                    </div>
                                 </div>
                                 <div class="col-sm-6">
                                    <div class="mb-3">
                                       <label class="control-label">Type <span class="text-danger">*</span></label>
                                      
                                          <select class="form-select" v-model="attribute.type"  v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                             <option :value="null" disabled>-- Select Type --</option>
                                             <option v-for="type in types" :key="type.id" :value="type.id">{{type.name}}</option>
                                          </select>
                                          <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback"> 
                                             <p class="mb-0">{{val}}</p>
                                          </div> 
                                    </div>
                                 </div>
                              </div>

                               <div class="row">
                                 <div class="col-sm-6">
                                    <div class="mb-3">
                                     <label class="control-label">Category Type <span class="text-danger">*</span></label>
												<select class="form-control" v-model="attribute.cat_type" v-bind:class="{ 'is-invalid': Boolean(errors.cat_type) }">
													<option :value="null" disabled>-- Select Type --</option>
													<option v-for="type in category_types" :key="type.id" :value="type.id">{{ type.name }}</option>
												</select>
												<div v-for="(val, index) in errors.cat_type" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
                                    </div>
                                 </div>
                              </div>
                             
                             <div class="col-sm-6">
                                <button type="submit" class="btn btn-primary me-3">Add</button>
                                <button class="btn btn-light">Reset</button>
                             </div>
                             <projectForm />
                          </div>
                       </form>
                    </div>
                 </div>
              </div>
           </div>
        </div>

  </div>
</template>



<script>
export default {
   name:'AddAttribute',
   data() {
      return {
         attribute: {
            id: null,
            name: "",
            type: null,
            cat_type:null,            
         },  
         types: {},
         category_types: {},
         inputs: [
            {value: ''}
         ],
         attribute_values: [],         
         token: '',
         errors: {}
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchAttributeTypes();
      this.fetchCategoryTypes();
   },

   methods: {    

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

      fetchCategoryTypes() {
				this.getToken();
				this.$axios
					.get("/api/admin/category/types", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.category_types = responseData.data;
						console.log(this.types);
					})
					.catch((err) => console.log(err));
			},

      fetchAttributeTypes() {
         this.getToken();
         this.$axios
            .get("/api/admin/attributes/types",{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data;
               this.types = responseData.data;
               
            })
            .catch(err => console.log(err));
      },

      add() {
         this.inputs.push({ value: '' });
      },

      remove(index) {
         this.inputs.splice(index, 1);
      }, 

      addAttribute(){
         this.getToken();   
         this.inputs.forEach(obj => {
            if(obj.value != '') {
               this.attribute_values.push(obj.value);
            }            
         })           
         let formData = new FormData();  
         formData.append('name', this.attribute.name);
         formData.append('type', this.attribute.type);  
         formData.append('cat_type', this.attribute.cat_type);         
         formData.append('attribute_values', JSON.stringify(this.attribute_values));       
         
         const config = {
              headers: {
                  
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         let url;
         url = '/api/admin/attributes/add';
         
          this.$axios
          .post(url, formData, config)
          .then(response => {
              if(response.data.status) {
               this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
              this.clearForm();              
          })
          .catch(error => {
              
               if(error.response){
                  if(error.response.data.message){
                     console.log(error.response.data);
                     this.errors = error.response.data.message;
                     this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
               
          }); 
               
       },

      clearForm() {
         this.attribute.name = '';
         this.attribute.type = null;
         this.attribute.cat_type = null;
         this.attribute_values = [];   
         this.inputs = [{value: ''}];      
         this.errors = {};
      },
      
   }   
}
</script> 